// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const TenantsOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={`min-icon`}
      fill={"currentcolor"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 230.355 244.478"
      {...props}
    >
      <path
        data-name="Trazado 395 - Contorno"
        d="M163.418 244.477a40.409 40.409 0 01-40.336-40.391 40.334 40.334 0 017.428-23.329l-28.589-37.162a73.171 73.171 0 01-19.721 4.874l-.838 15.423a23.685 23.685 0 016.886 16.732 23.807 23.807 0 01-23.77 23.792 23.808 23.808 0 01-23.77-23.792 23.672 23.672 0 0117.239-22.894l.575-10.549A74.931 74.931 0 01-.002 74.45 74.485 74.485 0 0174.35.001a74.488 74.488 0 0174.359 74.449 74.5 74.5 0 01-1.064 12.52l27.5 4a30.224 30.224 0 0124.579-12.382 30.684 30.684 0 0130.634 30.668 30.682 30.682 0 01-30.631 30.663 30.809 30.809 0 01-30.238-25.79l-29.708-4.319a74.988 74.988 0 01-17.4 21.463l26.916 35a40.4 40.4 0 0114.12-2.573 40.41 40.41 0 0140.343 40.385 40.413 40.413 0 01-40.342 40.392zm-15.989-61.17l-2.571 2.638a25.849 25.849 0 00-7.4 18.141 26.006 26.006 0 0025.956 26 26.007 26.007 0 0025.956-26 26 26 0 00-25.956-25.992 25.883 25.883 0 00-12.765 3.388zm-82.758-12.07a9.4 9.4 0 00-9.571 9.386 9.4 9.4 0 009.38 9.392 9.4 9.4 0 009.379-9.392 9.423 9.423 0 00-4.01-7.7l-2.332-1.635zm9.68-156.843A60.076 60.076 0 0014.39 74.448a60.046 60.046 0 0052.543 59.576l4.164.514 4.162-.063a59.2 59.2 0 0025.7-6.213l3.823-1.9 3.414-2.351a60.156 60.156 0 0020.888-25.027l1.712-3.818 1.2-4.187a60.311 60.311 0 002.32-16.532 60.079 60.079 0 00-59.964-60.053zm109.392 90.51l-.21 3.387c-.055 9.932 7.233 17.231 16.19 17.231a16.275 16.275 0 0016.245-16.269 16.278 16.278 0 00-16.245-16.274 16.145 16.145 0 00-14.51 9.006z"
      />
    </svg>
  );
};

export default TenantsOutlineIcon;
